import React from 'react';
// import style from './TextColumns.module.scss';

interface TextColumnsProps {
  // add Text Columns props here
  children: React.ReactNode;
  className?: string;

}

const TextColumns: React.FC<TextColumnsProps> = ({ children, className }: TextColumnsProps) => (
  <div
    className={`text-columns ${className || ''}`}
  >
    {children}
  </div>
);

export default TextColumns;
